import { CommandType } from "~/constants/commands"
import { serverConfig } from "~/utils/ssr"

const DEFAULT_AGENT_TYPE = CommandType.INPUT_OUTPUT_EXAMPLE_TO_DWL_GENERATION

export const useCampaignAgentType = () => {
  return serverConfig('agent_type') as CommandType ?? DEFAULT_AGENT_TYPE
}